import { render, staticRenderFns } from "./Mrz.vue?vue&type=template&id=c9b2f4da"
import script from "./Mrz.vue?vue&type=script&lang=js"
export * from "./Mrz.vue?vue&type=script&lang=js"
import style0 from "./Mrz.vue?vue&type=style&index=0&id=c9b2f4da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports